import { SuratJalanStatus } from "../types/suratJalan";
import type { User } from "../types/user";
import { isFinance, isFinanceInvoicing, isUserAdmin } from "../types/user";

export interface SuratJalanActionAvailability {
  canVerify: boolean;
  canApprove: boolean;
  canRevise: boolean;
}

export const getSuratJalanActionAvailability = (
  user: User | null,
  status: SuratJalanStatus,
): SuratJalanActionAvailability => {
  const canVerify = !!user && (isFinance(user) || isUserAdmin(user));
  const canInvoice = !!user && (isFinanceInvoicing(user) || isUserAdmin(user));
  const inReview = status === SuratJalanStatus.IN_REVIEW;
  const invoicingReview = status === SuratJalanStatus.INVOICING_REVIEW;

  return {
    canVerify: canVerify && inReview,
    canApprove: canInvoice && invoicingReview,
    canRevise: (canVerify && inReview) || (canInvoice && invoicingReview),
  };
};

export const hasSuratJalanRowActions = (user: User | null): boolean => {
  if (!user) {
    return false;
  }
  return isFinance(user) || isFinanceInvoicing(user) || isUserAdmin(user);
};
